import m, {Vnode} from "mithril";
import {VideoItem} from "../../../../model/items/video";

export default class Video {
    constructor(
        private readonly cellItem: VideoItem
    ) { }

    public view(): Vnode {

        return m('.video', {}, [
            m("video", {}, '... video not implemented yet ...') // TODO
        ]);
    }
}